export * from './sidebar.directive';



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/directives/sidebar/index.ts